<h2 mat-dialog-title>
  {{ 'AUTOMATIONS.END_RUN.END_AUTOMATION_RUN' | translate }}
</h2>
<mat-dialog-content>
  <div class="dialog-content">
    {{ 'AUTOMATIONS.END_RUN.END_RUN_CONFIRMATION' | translate }}
    <glxy-alert type="info">
      {{ 'AUTOMATIONS.END_RUN.END_RUN_INFO' | translate }}
    </glxy-alert>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-flat-button mat-dialog-close [disabled]="processing">
    {{ 'COMMON.ACTION_LABELS.CANCEL' | translate }}
  </button>
  <button mat-flat-button color="primary" (click)="endRun()" [disabled]="processing">
    {{ 'COMMON.ACTION_LABELS.CONFIRM' | translate }}
  </button>
</mat-dialog-actions>
